import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetosataracabservice() {



  const cardData = {
"keyword": "Pune to Satara Cab Service",

"headingDescription":
  "Shivai Travels offers reliable and comfortable Pune to Satara Cab Service for travelers seeking safe, affordable, and convenient intercity transportation. Whether you are traveling for business, family visits, tourism, trekking trips, or weekend getaways, our taxi service ensures a smooth and stress-free journey. With experienced drivers, clean air-conditioned vehicles, and transparent pricing with no hidden charges, we provide a dependable travel experience from Pune to Satara. Our fleet includes sedans, SUVs, and premium cars suitable for solo travelers, families, and corporate clients. With flexible one-way and round-trip options, doorstep pickup, and 24/7 customer support, Shivai Travels ensures a comfortable and timely travel experience between Pune and Satara.",

"topPlaces": [
  {
    "title": "Kaas Plateau (Valley of Flowers)",
    "description":
      "Kaas Plateau is a UNESCO World Natural Heritage Site near Satara known for seasonal wildflowers and scenic landscapes. Travelers using Pune to Satara cab service often visit this beautiful natural attraction during blooming season."
  },
  {
    "title": "Thoseghar Waterfall",
    "description":
      "Thoseghar Waterfall is one of Maharashtra’s most famous waterfalls located near Satara. Cab travelers from Pune frequently visit this stunning monsoon destination for nature views and photography."
  },
  {
    "title": "Ajinkyatara Fort",
    "description":
      "Ajinkyatara Fort is a historic hill fort in Satara offering panoramic views of the city and surrounding valleys. Pune to Satara cab service provides easy access for history and trekking enthusiasts."
  },
  {
    "title": "Sajjangad Fort",
    "description":
      "Sajjangad Fort is a revered pilgrimage site associated with Saint Ramdas. Travelers from Pune often visit this spiritual destination for blessings and historical significance."
  },
  {
    "title": "Natraj Mandir Satara",
    "description":
      "Natraj Mandir is a well-known cultural and religious landmark in Satara. Cab service from Pune ensures convenient travel for devotees and tourists."
  },
  {
    "title": "Kas Lake",
    "description":
      "Kas Lake is a peaceful water reservoir near Satara surrounded by greenery. Travelers from Pune often visit this calm and scenic location for relaxation."
  },
  {
    "title": "Chalkewadi Windmill Farms",
    "description":
      "Chalkewadi Windmill Farms is a scenic hilltop area known for windmills and panoramic views. Pune to Satara cab service offers comfortable travel for sightseeing enthusiasts."
  },
  {
    "title": "Lingamala Falls",
    "description":
      "Lingamala Falls is a beautiful waterfall near Mahabaleshwar route from Satara, known for its natural beauty. Cab travelers from Pune often include it in their trip plans."
  },
  {
    "title": "Shri Bhavani Museum",
    "description":
      "Shri Bhavani Museum showcases artifacts, historical items, and exhibits related to Maratha history. Taxi service from Pune makes it easy to explore this cultural site."
  },
  {
    "title": "Satara City Garden",
    "description":
      "Satara City Garden is a well-maintained public park ideal for family visits and leisure time. Pune to Satara cab service provides easy access to this relaxing spot."
  }
],



services: [
  {
    name: "Pune to Jalgaon Cab",
    description: "Pune to Jalgaon cab service provides reliable transportation between Pune and Jalgaon with comfortable vehicles and experienced drivers. Vehicles are suitable for highway travel ensuring smooth and safe journeys for families, tourists, and business travelers. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune and Jalgaon. Vehicles include sedans, SUVs, Innova Crysta, Ertiga, and premium taxis suitable for different travel requirements. Flexible booking options allow convenient one-way and round-trip cab reservations."
  },
  {
    name: "Pune to Jalgaon Taxi",
    description: "Pune to Jalgaon taxi service offers dependable transportation for passengers traveling between Pune and Jalgaon with professional chauffeurs and comfortable vehicles. Vehicles provide spacious seating and smooth highway travel suitable for business trips, tourism, and family journeys. Professional drivers ensure punctual pickup and safe driving services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune and Jalgaon. Flexible booking options allow convenient taxi reservations."
  },
  {
    name: "Cab from Pune to Jalgaon",
    description: "Cab from Pune to Jalgaon service provides comfortable intercity transportation for passengers traveling for business, tourism, and family visits. Vehicles ensure reliable highway travel with experienced chauffeurs offering safe and smooth journeys. Pickup services are available from residential areas, offices, hotels, railway stations, and airports across Pune and Jalgaon. Ideal for one-way and round-trip travel requirements. Flexible booking options allow convenient cab reservations."
  },
  {
    name: "Taxi from Pune to Jalgaon",
    description: "Taxi from Pune to Jalgaon service offers reliable transportation with comfortable vehicles and professional drivers for long-distance travel between Pune and Jalgaon. Vehicles provide smooth highway travel suitable for tourism, business meetings, and family trips. Professional drivers ensure safe driving and timely pickup services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune and Jalgaon. Flexible booking options allow easy taxi reservations."
  },
  {
    name: "Pune to Jalgaon Cab Service",
    description: "Pune to Jalgaon cab service provides dependable transportation solutions for passengers traveling between Pune and Jalgaon with comfortable vehicles and experienced chauffeurs. Vehicles are suitable for highway travel ensuring safe and smooth journeys for individuals, families, and corporate travelers. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune and Jalgaon. Ideal for business travel, tourism, and family trips. Flexible booking options allow convenient cab reservations."
  },
  {
    name: "Pune to Jalgaon Taxi Fare",
    description: "Pune to Jalgaon taxi fare service provides transparent pricing information for passengers planning intercity travel between Pune and Jalgaon. Travelers can estimate transportation costs based on vehicle type, travel distance, and trip requirements. Comfortable vehicles ensure smooth highway travel with professional drivers offering safe transportation services. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune and Jalgaon. Flexible booking options allow convenient fare estimation and taxi reservations."
  },
  {
    name: "Pune to Jalgaon One Way Cab",
    description: "Pune to Jalgaon one way cab service provides economical transportation for passengers traveling from Pune to Jalgaon without return travel requirements. Comfortable vehicles ensure smooth highway travel suitable for business trips, tourism, and family visits. Professional drivers ensure punctual pickup and safe driving services throughout the journey. Pickup services are available across Pune and Jalgaon including homes, hotels, offices, railway stations, and airports. Flexible booking options allow convenient one-way cab reservations."
  },
  {
    name: "Pune to Jalgaon Round Trip Taxi",
    description: "Pune to Jalgaon round trip taxi service offers convenient return transportation for passengers planning travel between Pune and Jalgaon. Comfortable vehicles provide smooth highway journeys with experienced drivers ensuring safe and reliable transportation services. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune and Jalgaon. Ideal for business travel, tourism, and family trips. Flexible booking options allow convenient round-trip taxi reservations."
  },
  {
    name: "Pune to Jalgaon Cab Booking",
    description: "Pune to Jalgaon cab booking service allows passengers to reserve comfortable intercity transportation between Pune and Jalgaon. Vehicles include sedans, SUVs, luxury cars, Innova Crysta, and premium taxis suitable for different passenger requirements. Professional drivers ensure safe driving and punctual pickup services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune and Jalgaon. Flexible booking options allow instant and advance cab reservations."
  },
  {
    name: "Cheap Pune to Jalgaon Cab",
    description: "Cheap Pune to Jalgaon cab service provides affordable transportation between Pune and Jalgaon with comfortable vehicles and economical pricing. Vehicles ensure reliable highway travel suitable for tourism, business travel, and family journeys. Professional drivers ensure safe driving and timely pickup services throughout the trip. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune and Jalgaon. Flexible booking options allow convenient low-cost cab reservations."
  },
  {
    name: "Best Pune to Jalgaon Taxi",
    description: "Best Pune to Jalgaon taxi service offers premium transportation with comfortable vehicles and professional chauffeurs for smooth intercity travel. Vehicles provide spacious seating, luggage capacity, and reliable highway performance suitable for business travel, tourism, and family trips. Professional drivers ensure safe driving and punctual pickup services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune and Jalgaon. Flexible booking options allow convenient taxi reservations."
  },
  {
    name: "Sedan Pune to Jalgaon Cab",
    description: "Sedan Pune to Jalgaon cab service offers economical and comfortable transportation for solo travelers, couples, and small families traveling between Pune and Jalgaon. Sedan vehicles provide smooth highway travel with comfortable seating and luggage space suitable for intercity journeys. Professional drivers ensure punctual pickup and safe driving services throughout the trip. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune and Jalgaon. Flexible booking options allow convenient sedan cab reservations."
  },
  {
    name: "SUV Pune to Jalgaon Taxi",
    description: "SUV Pune to Jalgaon taxi service provides spacious transportation for families and groups traveling between Pune and Jalgaon. SUV vehicles offer comfortable seating, luggage capacity, and smooth highway performance suitable for long-distance journeys. Professional chauffeurs ensure safe driving and timely pickup services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune and Jalgaon. Flexible booking options allow convenient SUV taxi reservations."
  },
  {
    name: "Innova Pune to Jalgaon Cab",
    description: "Innova Pune to Jalgaon cab service provides premium SUV transportation for passengers seeking comfortable and reliable intercity travel. Innova vehicles offer spacious seating, smooth ride quality, and luggage space suitable for business travel, tourism, and family trips. Professional drivers ensure safe driving and punctual pickup services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune and Jalgaon. Flexible booking options allow convenient Innova cab reservations."
  },
  {
    name: "Pune to Dhule Cab Service",
    description: "Pune to Dhule cab service provides reliable transportation between Pune and Dhule with comfortable vehicles and experienced chauffeurs. Vehicles ensure smooth highway travel suitable for business trips, tourism, and family travel requirements. Professional drivers ensure safe driving and timely pickup services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune and Dhule. Flexible booking options allow convenient one-way and round-trip cab reservations."
  },
  {
    name: "Intercity Cab Pune Dhule",
    description: "Intercity cab Pune Dhule service offers dependable long-distance transportation between Pune and Dhule with comfortable vehicles and professional drivers. Vehicles provide spacious seating and smooth highway performance suitable for family trips, tourism, and business travel. Professional chauffeurs ensure punctual pickup and safe driving services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune and Dhule. Flexible booking options allow convenient intercity cab reservations."
  }
],

tableData: [
  ["Pune to Jalgaon Cab", "Pune to Jalgaon Taxi"],
  ["Cab from Pune to Jalgaon", "Taxi from Pune to Jalgaon"],
  ["Pune to Jalgaon Cab Service", "Pune to Jalgaon Taxi Fare"],
  ["Pune to Jalgaon One Way Cab", "Pune to Jalgaon Round Trip Taxi"],
  ["Pune to Jalgaon Cab Booking", "Cheap Pune to Jalgaon Cab"],
  ["Best Pune to Jalgaon Taxi", "Sedan Pune to Jalgaon Cab"],
  ["SUV Pune to Jalgaon Taxi", "Innova Pune to Jalgaon Cab"],
  ["Pune to Dhule Cab Service", "Intercity Cab Pune Dhule"]
],



 whychoose: [
      {
        WhyChooseheading: "Reliable Pune to Satara Cab Service",
        WhyChoosedescription: "Shivai Travels provides reliable Pune to Satara cab service with professional drivers, comfortable vehicles, and punctual pickup for smooth and safe intercity travel."
      },
      {
        WhyChooseheading: "Affordable Pune to Satara Taxi Fare",
        WhyChoosedescription: "Shivai Travels offers affordable Pune to Satara cab pricing with transparent fare details and no hidden charges. Customers receive complete fare information before confirming their booking."
      },
      {
        WhyChooseheading: "24/7 Satara Cab Service Availability",
        WhyChoosedescription: "Our Pune to Satara cab service operates 24 hours a day for family trips, business travel, temple visits, emergency transportation, and airport transfers."
      },
      {
        WhyChooseheading: "Comfortable & Clean AC Cabs",
        WhyChoosedescription: "All taxis provided by Shivai Travels are fully air-conditioned, sanitized, and regularly maintained to provide comfortable long-distance travel experiences for passengers."
      },
      {
        WhyChooseheading: "One Way & Round Trip Cab Booking",
        WhyChoosedescription: "Shivai Travels offers flexible travel options including one-way Pune to Satara taxi service, round-trip bookings, sightseeing tours, and customized travel packages."
      },
      {
        WhyChooseheading: "Wide Range of Cab Vehicle Choices",
        WhyChoosedescription: "Customers can choose from sedan taxis, Ertiga, Innova, premium Innova Crysta vehicles, and Tempo Travellers suitable for individuals, families, business travelers, and group tours."
      },
      {
        WhyChooseheading: "Doorstep Pickup Across Pune",
        WhyChoosedescription: "Shivai Travels provides convenient pickup from homes, offices, hotels, Pune Airport, railway stations, and all major Pune locations including Baner, Wakad, Hinjewadi, Kharadi, and Hadapsar."
      },
      {
        WhyChooseheading: "Experienced Drivers for Highway Travel",
        WhyChoosedescription: "Our experienced drivers are familiar with Pune to Satara highway routes and ensure safe driving, smooth travel, and timely arrival for every journey."
      }
    ]
  };

  const faqData = [
    { question: "What is Pune to Satara cab service?", answer: "Pune to Satara cab service provides comfortable taxi transportation between Pune and Satara for family trips, business travel, sightseeing, and outstation journeys." },
    { question: "Is Pune to Satara cab service available 24 hours?", answer: "Yes, Shivai Travels provides 24/7 Pune to Satara cab service." },
    { question: "Which vehicles are available for Pune to Satara travel?", answer: "Shivai Travels offers sedan taxis, Ertiga, Innova, Innova Crysta, and Tempo Travellers." },
    { question: "Can I book a one-way cab from Pune to Satara?", answer: "Yes, customers can book one-way as well as round-trip Pune to Satara taxi services." },
    { question: "Do you provide sightseeing cab service in Satara?", answer: "Yes, Shivai Travels provides sightseeing and customized travel packages for Satara and nearby destinations." },
    { question: "Are all Pune to Satara taxis air-conditioned?", answer: "Yes, all taxis are fully air-conditioned and maintained for comfortable long-distance travel." },
    { question: "Can I book Pune to Satara cab service online?", answer: "Yes, customers can easily book Pune to Satara cab service online or through phone booking." },
    { question: "Do you provide cabs for family and group travel?", answer: "Yes, Shivai Travels provides comfortable vehicles suitable for family tours and group travel." },
    { question: "Are Pune to Satara cab fares transparent?", answer: "Yes, Shivai Travels provides affordable and transparent pricing without hidden charges." },
    { question: "Is advance booking available for Pune to Satara cab service?", answer: "Yes, advance booking is available and recommended during weekends, holidays, and festive seasons." }
  ];

  const testimonials = [
    {
      id: 1,
      name: "Mr. Rohit More",
      feedback:
        "Booked Pune to Satara cab service with Shivai Travels. Clean vehicle, experienced driver, and smooth highway journey.",
      rating: 5
    },
    {
      id: 2,
      name: "Mrs. Pooja Patwardhan",
      feedback:
        "Excellent Pune to Satara taxi service. Affordable pricing, punctual pickup, and comfortable travel experience.",
      rating: 5
    }
  ];





































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Pune Outstation Cab Service", link: "Pune-Outstation-Cab-Service" },
    { place: "/images/keyword/2.jpg", text: "Pune Taxi Service", link: "Pune-Taxi-Service" },
    { place: "/images/keyword/3.jpg", text: "Pune Cab Booking", link: "Pune-Cab-Booking" },
    { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
    { place: "/images/keyword/5.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    { place: "/images/keyword/6.jpg", text: "Cheap Cabs in Pune", link: "Cheap-Cabs-in-Pune" },
    { place: "/images/keyword/7.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
    { place: "/images/keyword/8.jpg", text: "Corporate Cab Service Pune", link: "Corporate-Cab-Service-Pune" },
    { place: "/images/keyword/9.jpg", text: "Pune Airport Cab", link: "Pune-Airport-Cab" },
    { place: "/images/keyword/10.jpg", text: "Pune Railway Station Cab Service", link: "Pune-Railway-Station-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Pune One Way Cab Service", link: "Pune-One-Way-Cab-Service" },
    { place: "/images/keyword/12.jpg", text: "Pune Local and Outstation Cab", link: "Pune-Local-and-Outstation-Cab" },
    { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/15.jpg", text: "Pune to Nashik Cab Service", link: "Pune-to-Nashik-Cab-Service" },
    { place: "/images/keyword/16.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
    { place: "/images/keyword/17.jpg", text: "Pune to Kolhapur Cab", link: "Pune-to-Kolhapur-Cab" },
    { place: "/images/keyword/18.jpg", text: "Pune to Solapur Cab Service", link: "Pune-to-Solapur-Cab-Service" },
    { place: "/images/keyword/19.jpg", text: "Pune to Ahmednagar Taxi", link: "Pune-to-Ahmednagar-Taxi" },
    { place: "/images/keyword/20.jpg", text: "Pune to Sangli Cab", link: "Pune-to-Sangli-Cab" },
    { place: "/images/keyword/21.jpg", text: "Pune to Satara Cab Service", link: "Pune-to-Satara-Cab-Service" },
    { place: "/images/keyword/22.jpg", text: "Pune to Jalgaon Cab Service", link: "Pune-to-Jalgaon-Cab-Service" },
    { place: "/images/keyword/23.jpg", text: "Pune to Dhule Cab Service", link: "Pune-to-Dhule-Cab-Service" },
    { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
    { place: "/images/keyword/25.jpg", text: "Pune to Panvel Cab", link: "Pune-to-Panvel-Cab" },

  ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Satara Cab Service",
  "image": "https://shivaitravels.com/assets/images/pune-to-satara-cab.jpg",
  "description": "Book Pune to Satara cab service for safe and comfortable highway travel. Shivai Travels offers affordable one-way and round-trip taxi booking with sedan, SUV, Innova, and luxury cab options available 24x7.",
  "brand": {
    "@type": "Brand",
    "name": "Shivai Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5471"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹11/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://shivaitravels.com/pune-to-satara-cab-service"
  }
};







  return (
    <div>


<Helmet>
  <title>Pune to Satara Cab Service | Affordable Highway Taxi | +91 9689815477</title>

  <meta
    name="description"
    content="Book Pune to Satara cab service for one-way and round trip travel. Affordable taxi options including sedan, SUV, Innova, and luxury cabs available 24x7 for safe highway journeys."
  />

  <meta
    name="keywords"
    content="pune to satara cab service, pune to satara taxi, cab from pune to satara, taxi from pune to satara, pune to satara cab booking, pune to satara one way cab, pune to satara round trip taxi, cheap pune to satara cab, best pune to satara taxi, sedan pune to satara cab, suv pune to satara taxi, innova pune to satara cab, highway cab pune satara, Pune to Satara Cab Service, Pune to Satara Taxi Service, Pune to Satara Cab Booking, Best Pune to Satara Cab, One Way Pune to Satara Cab, Round Trip Pune to Satara Taxi"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



      <div className="breadcrumb-bar">
        <div className="container">
          <div className="row align-items-center text-center">
            <div className="col-md-12 col-12">
              <h2 className="breadcrumb-title text-white"> {cardData.keyword}</h2>

            </div>
          </div>
        </div>
      </div>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/21.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#3F1B0D', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Shivai Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shivai Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shivai Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919689815477" className="pc-call">+91 9689815477</a>
                    </div>

                    <div className="pc-cta">
                    <a
  href="https://wa.me/919689815477?text=Welcome%20to%20Shivai%20Travels!%20%F0%9F%9A%8C%0AWe%20are%20happy%20to%20assist%20you%20with%20comfortable%20and%20safe%20travel%20services.%20Please%20let%20us%20know%20how%20we%20can%20help%20you."
  target="_blank"
  rel="noopener noreferrer"
  className="pc-whats"
>
  <i className="bi bi-whatsapp"></i> WhatsApp
</a>
                      <a href="tel:+919689815477" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shivaitravels.com" className="pc-email">
                      booking@shivaitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shivai Travels</strong><br />
                      Shop no 1, Kamdhenu nagar, Guru mauli society, Vadgaon road, Near super bazar, Alandi, Pune 412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetosataracabservice;